export const SUPPLIER_SELECT_LABEL = 'Lieferant';
export const SUPPLIER_SELECT_PLACEHOLDER = 'Lieferant auswaehlen';
export const SUPPLIER_SELECT_NO_OPTIONS = 'Keine Lieferanten gefunden';
export const SUPPLIER_SELECT_LOADING = 'Lieferanten werden geladen...';
export const SUPPLIER_SELECT_EMPTY_HELPER =
    'Keine Lieferanten vorhanden. Bitte zuerst einen Lieferanten anlegen.';

export const normalizeSupplierLabel = (value) =>
    typeof value === 'string' ? value.trim() : '';

export const buildSupplierDisplayName = (supplier) => {
    const name = normalizeSupplierLabel(supplier?.name);
    return name || 'Unbenannter Lieferant';
};

export const buildSupplierOptions = (suppliers = []) =>
    suppliers
        .filter(Boolean)
        .map((supplier) => {
            const displayName = buildSupplierDisplayName(supplier);
            const matchKeys = [displayName, normalizeSupplierLabel(supplier?.name)].filter(Boolean);
            return {
                id: supplier?.id || '',
                label: displayName,
                displayName,
                matchKeys,
            };
        });

const normalizeSearchValue = (value) => normalizeSupplierLabel(value).toLowerCase();

export const findMatchingSupplierOption = (options, value) => {
    const normalized = normalizeSearchValue(value);
    if (!normalized) {
        return null;
    }
    return (
        options.find((option) =>
            option.matchKeys.some((key) => normalizeSearchValue(key) === normalized)
        ) || null
    );
};

export const resolveSupplierOption = (options, id, name) => {
    if (id) {
        const selected = options.find((option) => option.id === id);
        if (selected) {
            return selected;
        }
    }
    if (!name) {
        return null;
    }
    return findMatchingSupplierOption(options, name);
};

export const getSupplierOptionLabel = (option) =>
    option?.label || option?.displayName || '';

export const isSupplierOptionEqualToValue = (option, value) =>
    Boolean(option && value && option.id === value.id);
